<mat-toolbar color="gray">
    <div class="d-flex" [ngClass]="{ 'p-fixed': isFocusMode }">
        <div class="flex-center">
            <!-- Phone: one tap to Home from every module, far left (DESIGN.md
                 §Layout RULE 2026-08-10; audit F2 found no phone Home anywhere). -->
            <button
                *ngIf="isSmallDisplay"
                mat-icon-button
                class="header-home-btn"
                routerLink="app/home"
                aria-label="Home"
                title="Home"
                data-cy="header-home-btn"
            >
                <mat-icon>home</mat-icon>
            </button>
            <!-- Desktop only: on phones the bottom bar's Menu sheet IS the main
                 navigation (and this drawer rendered under the status bar). -->
            <button class="main-menu-toggle" mat-icon-button aria-label="Expand main Menu" (click)="emitToggle()">
                <mat-icon>menu</mat-icon>
            </button>
            <span class="brand" routerLink="app/home" [ngClass]="{ 'fs-0': isSmallDisplay }">Newgenus</span>
        </div>
    </div>

    <span class="flex-spacer"></span>

    <span *ngIf="hasWorkspaceAccess" class="basket-badges">
        <span
            class="basket-badge clickable"
            title="Go to Inbasket"
            role="button"
            routerLink="app/workspace/inbasket"
            data-cy="header-inbasket-link"
        >
            <img src="/assets/icons/NEW-Icons-16.svg" class="filter-black basket-icon" alt="inbasket" />
            <span
                class="basket-count"
                [class.count-green]="inbasketCount === 0"
                [class.count-yellow]="inbasketCount > 0 && inbasketCount <= 20"
                [class.count-orange]="inbasketCount > 20 && inbasketCount <= 100"
                [class.count-red]="inbasketCount > 100"
                data-cy="inbasket-particle-count"
                >{{ inbasketCount }}</span
            >
            <span class="basket-label">inbasket</span>
        </span>
        <span
            class="basket-badge clickable"
            title="Go to Pending"
            role="button"
            routerLink="app/workspace/pending"
            data-cy="header-pending-link"
        >
            <img src="/assets/icons/NEW-Icons-17.svg" class="filter-black basket-icon" alt="pending" />
            <span
                class="basket-count"
                [class.count-green]="pendingCount === 0"
                [class.count-yellow]="pendingCount > 0 && pendingCount <= 20"
                [class.count-orange]="pendingCount > 20 && pendingCount <= 100"
                [class.count-red]="pendingCount > 100"
                data-cy="pending-particle-count"
                >{{ pendingCount }}</span
            >
            <span class="basket-label">pending</span>
        </span>
    </span>

    <!-- Phone: quick jump to workspace search, shown ONLY on the workspace view
         (search is workspace-scoped for now, not app-wide). Phones only — desktop
         reaches it via the sidebar. -->
    <button
        *ngIf="hasWorkspaceAccess && isSmallDisplay && isWorkspaceRoute"
        mat-icon-button
        class="header-search-btn"
        routerLink="app/workspace/search"
        aria-label="Search"
        title="Search"
        data-cy="header-search-link"
    >
        <mat-icon>search</mat-icon>
    </button>

    <a
        href="mailto:support@newgenus.org"
        target="_blank"
        rel="noopener noreferrer"
        class="d-none d-sm-block"
        #supportBtn
    >
        <button class="support-btn" mat-icon-button aria-label="Contact Support" title="Contact Support">
            <mat-icon>contact_support</mat-icon>
        </button>
    </a>

    <!-- Full Notification System Bell -->
    <ng-container *ngModuleOn="'notifications'">
        <newgenus-notification-bell *ngIf="security.isOrgAvailableForUser()"></newgenus-notification-bell>
    </ng-container>

    <!-- Desktop/tablet: labelled org trigger in the toolbar. On phones it ate
         too much toolbar space, so there it lives in the profile menu instead
         (submenu item below). -->
    <button
        *ngIf="security.isOrgAvailableForUser() && !isSmallDisplay"
        mat-stroked-button
        class="org-switcher-btn"
        [matMenuTriggerFor]="orgMenu"
        aria-label="Switch organization"
    >
        <mat-icon class="org-switcher-leading">corporate_fare</mat-icon>
        <span class="org-switcher-name">{{ selectedOrgDisplay || 'Organization' }}</span>
        <mat-icon iconPositionEnd>arrow_drop_down</mat-icon>
    </button>

    <!-- Phone: the submenu opens over/under its trigger item (overlapTrigger)
         instead of flying to the far screen edge; desktop keeps right-aligned. -->
    <mat-menu
        #orgMenu="matMenu"
        [xPosition]="isSmallDisplay ? 'after' : 'before'"
        [overlapTrigger]="isSmallDisplay"
        class="org-switcher-menu"
    >
        <button
            mat-menu-item
            *ngFor="let org of organizationList"
            [class.org-active]="org.value === selectedOrg"
            (click)="selectOrg(org.value)"
        >
            <mat-icon>{{ org.value === selectedOrg ? 'check' : '' }}</mat-icon>
            <span>{{ org.display }}</span>
        </button>
        <!-- the wizard is a dark-deploy module: while it is off the route guard refuses it, so the
             entry would do nothing (sandbox click-through, 2026-10-23) -->
        <ng-container *ngModuleOn="'org-creation-wizard'">
            <mat-divider></mat-divider>
            <button mat-menu-item (click)="selectOrg('__create_new_org__')">
                <mat-icon>add_circle_outline</mat-icon>
                <span>Create new organization</span>
            </button>
        </ng-container>
    </mat-menu>

    <span class="profile-button-wrapper">
        <button
            class="menu-button"
            mat-icon-button
            aria-label="Account Menu"
            data-cy="profile-picture"
            [matMenuTriggerFor]="menu"
            placement="bottom-right"
        >
            <mat-icon *ngIf="photoSrc" class="profile-icon-no-font">
                <img [attr.src]="photoSrc" alt="{{ userInitials }}" />
            </mat-icon>
            <span *ngIf="!photoSrc" class="header-avatar-initials" [style.background]="profileColor || null">{{
                userInitials
            }}</span>
        </button>
        <span *ngIf="appUpdateService.updateAvailable$ | async" class="profile-update-dot">
            <mat-icon class="update-dot-icon">sync</mat-icon>
        </span>
    </span>

    <mat-menu #menu="matMenu">
        <div class="profile-header" (click)="$event.stopPropagation()">
            <div class="profile-avatar-wrapper" (click)="openProfilePhotoDialog()">
                <span
                    class="avatar profile-avatar"
                    [style.background]="!photoSrc && profileColor ? profileColor : null"
                >
                    <img
                        *ngIf="photoSrc; else noProfileImg2"
                        [attr.src]="photoSrc"
                        alt="{{ (user.firstName || '') + (user.lastName || '') }}"
                    />
                    <ng-template #noProfileImg2>{{ userInitials }}</ng-template>
                </span>
                <span class="profile-camera-badge">
                    <mat-icon>photo_camera</mat-icon>
                </span>
            </div>
            <span class="profile-name">{{ (user.firstName || '') + ' ' + (user.lastName || '') | truncate: 20 }}</span>
            <span class="profile-email-text">{{ user.email || '' }}</span>
        </div>

        <!-- Organization switcher — PHONES only (desktop keeps the toolbar button) -->
        <button
            *ngIf="security.isOrgAvailableForUser() && isSmallDisplay"
            mat-menu-item
            id="org-selector"
            data-cy="menu-org-switcher"
            [matMenuTriggerFor]="orgMenu"
        >
            <mat-icon>corporate_fare</mat-icon>
            <span class="menu-org-name">{{ selectedOrgDisplay || 'Organization' }}</span>
        </button>

        <span *ngIf="user?.isDeveloper" mat-menu-item (click)="$event.stopPropagation()" class="menu-accordion">
            <mat-accordion mat-menu-item [displayMode]="'flat'" style="display: contents">
                <mat-expansion-panel>
                    <mat-expansion-panel-header collapsedHeight="48px" style="padding: 0px 16px">
                        <mat-panel-title><mat-icon>code</mat-icon>Dev Info</mat-panel-title>
                    </mat-expansion-panel-header>

                    <button mat-menu-item disabled>
                        <span>Env: {{ environment }}</span>
                    </button>
                    <button mat-menu-item disabled>
                        <span>Emulator: {{ emulator }}</span>
                    </button>
                </mat-expansion-panel>
            </mat-accordion>
        </span>

        <button
            mat-menu-item
            role="menuitemcheckbox"
            type="button"
            data-cy="theme-toggle-btn"
            (click)="toggleTheme($event)"
        >
            <mat-icon>{{ themeIcon }}</mat-icon>
            <span>Toggle Theme</span>
        </button>

        <!-- Account has links. -->
        <span *ngIf="hasWorkspaceAccess" (click)="$event.stopPropagation()" mat-menu-item class="menu-accordion">
            <mat-accordion mat-menu-item [displayMode]="'flat'" style="display: contents">
                <mat-expansion-panel>
                    <mat-expansion-panel-header collapsedHeight="48px" style="padding: 0px 16px">
                        <mat-panel-title>
                            <mat-icon>{{ isLinked ? 'link' : 'link_off' }}</mat-icon
                            >Services
                        </mat-panel-title>
                    </mat-expansion-panel-header>

                    <!-- Gmail -->
                    <button mat-menu-item (click)="isGmailLinked ? '' : linkGmailAccount()">
                        <mat-icon [ngClass]="{ green: isGmailLinked, yellow: !isGmailLinked }">{{
                            isGmailLinked ? 'power' : 'power_off'
                        }}</mat-icon>
                        <span>{{ isGmailLinked ? 'Gmail Connected' : 'Connect Gmail' }}</span>
                    </button>

                    <!-- Outlook -->
                    <button mat-menu-item (click)="isOutlookLinked ? '' : linkMicrosoftAccount()">
                        <mat-icon [ngClass]="{ green: isOutlookLinked, yellow: !isOutlookLinked }">{{
                            isOutlookLinked ? 'power' : 'power_off'
                        }}</mat-icon>
                        <span>{{ isOutlookLinked ? 'Outlook Connected' : 'Connect Outlook' }}</span>
                    </button>
                </mat-expansion-panel>
            </mat-accordion>
        </span>

        <button mat-menu-item type="button" (click)="supportBtn.click()">
            <mat-icon>contact_support</mat-icon>
            <span>Contact Support</span>
        </button>

        <button
            *ngIf="user?.isDeveloper"
            mat-menu-item
            type="button"
            [routerLink]="['/styleguide/general']"
            data-cy="nav-styleguide"
        >
            <mat-icon>format_shapes</mat-icon>
            <span>Style Guide</span>
        </button>

        <button mat-menu-item type="button" data-cy="settings-btn" (click)="goToUserSettings()">
            <mat-icon>settings</mat-icon>
            <span>Settings</span>
        </button>

        <button mat-menu-item type="button" data-cy="logout-btn" (click)="signOut()">
            <mat-icon>logout</mat-icon>
            <span>Logout</span>
        </button>

        <!-- Update Available Button -->
        <button
            *ngIf="appUpdateService.updateAvailable$ | async"
            mat-menu-item
            type="button"
            class="update-available-btn"
            (click)="appUpdateService.forceUpdate()"
        >
            <mat-icon class="update-icon">system_update</mat-icon>
            <span>Update Available</span>
        </button>

        <button mat-menu-item disabled class="app-version">
            <span>v{{ version.version || '' }} &middot; {{ version.hash || '' }} &#x1F680;</span>
        </button>
    </mat-menu>

    <!-- Fetch the signatures in the same fashion the browser would, this is meant to assist the caching process.
         display:none (not zero size): a dead signature URL painted the engine's
         broken-image glyph in the header despite the 0-attrs (OE-158 finding 6);
         display:none images are still fetched, so the cache warm-up is intact. -->
    <div class="signature-preload" style="display: none" *ngFor="let sig of invisibleSignatures">
        <img height="0" width="0" [attr.src]="sig" />
    </div>
</mat-toolbar>
